import { PropsWithChildren } from "react";

export type RowProps = PropsWithChildren & {
  css?: string;
};

export function Row(props: RowProps) {
  let className = props.css;
  if (className?.length === 0) {
    className = "row";
  }
  return <div className={className}>{props.children}</div>;
}

export type ColumnProps = PropsWithChildren & {
  size?: number;
  css?: string;
};

export function Column(props: ColumnProps) {
  let className = props.css;
  if (className?.length === 0) {
    className = "col";
    if (props.size ?? 0 > 0) {
      className += `-${props.size}`;
    }
  }

  return <div className={className}>{props.children}</div>;
}
